import { render } from "./BlDocumentSignatureAddRecipientForm.vue?vue&type=template&id=d89aed56&scoped=true"
import script from "./BlDocumentSignatureAddRecipientForm.vue?vue&type=script&lang=js"
export * from "./BlDocumentSignatureAddRecipientForm.vue?vue&type=script&lang=js"

import "./BlDocumentSignatureAddRecipientForm.vue?vue&type=style&index=0&id=d89aed56&scoped=true&lang=scss"

import exportComponent from "/tmp/7c12f39a-5a06-429e-8ff2-90249d9b2982/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d89aed56"]])

export default __exports__